// extracted by mini-css-extract-plugin
module.exports =  {"list":"sRe7KQSGoXi39EAF2ehi"};